import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import AssessmentFormsCreateEditForm from './Components/AssessmentFormsCreateEditForm';
import AssessmentFormsApi from './AssessmentFormsApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: AssessmentFormsCreateEditForm,
                getCreate: AssessmentFormsApi.create,
                defaults: {},
                successMessage: "AssessmentForms Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}